import React from 'react'
import { connect } from 'react-redux'
import { ApiProvider, Project } from '@leverege/api-redux'
import { RuleScreen } from '@leverege/ui-rule'
import { BreadcrumbActions } from '~/actions'
import SetupBlueprints from '../rule/SetupBlueprints'
import Loading from '../../views/Loading'

class ProjectRulesScreen extends React.Component {

  static contextType = ApiProvider.Context

  constructor( props ) {
    super( props )
    this.state = {
      loading : true
    }
  }

  componentDidMount() {
    // We need Blueprints and Relationships to be loaded
    const api = this.context
    const { projectId, ruleId, dispatch, rule } = this.props
    const projectActions = Project( projectId )
    dispatch( BreadcrumbActions.setBreadcrumbs( [ 
      { link : `/project/${projectId}`, name : 'rules' } 
    ] ) )

    this.setState( { loading : true, error : null } )
    SetupBlueprints.run( api, projectId, {} )
      .then( 
        ( ) => { this.setState( { loading : false, error : null } ) },
        ( error ) => { console.error( error ); this.setState( { loading : false, error } ) }
      )

    if ( !rule ) {
      dispatch( projectActions.rule( ruleId ).get() )
        .then( 
          ( rule ) => { 
            dispatch( BreadcrumbActions.setBreadcrumbs( [ 
              { link : `/project/${projectId}/rule`, name : 'rules' },
              { name : rule.name }
            ] ) ) 
          },
          ( error ) => { console.error( error ); this.setState( { loading : false, error } ) }
        )
    } else {
      dispatch( BreadcrumbActions.setBreadcrumbs( [ 
        { link : `/project/${projectId}/rule`, name : 'rules' },
        { name : rule.name }
      ] ) ) 
    }
  }

  render() {
    const { projectId, rule } = this.props
    const { loading, error } = this.state
    if ( error ) {
      return (
        <div>Error loading: {error.message}</div>
      )
    }
    if ( loading || rule == null ) {
      return (
        <Loading show message="Loading"/>
      )
    }
    const actions = Project( projectId )
    
    return (
      <RuleScreen 
        delegate={actions} 
        rule={rule}/>
    )
  }
}

export default connect(
  ( state, props ) => {
    const { projectId, ruleId } = props?.match?.params || {}
    return {
      projectId, 
      ruleId,
      rule : state.rules[projectId]?.lookup?.[ruleId]
    }
  }
)( ProjectRulesScreen )
